import { memo } from 'react';
import styled from 'foundations-theming/utils';
import { flexColumnStyles } from '../constants/flexColumnStyles';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { Flex } from 'foundations-components/components/Flex';
import { SkeletonGradient } from 'conversations-skeleton-state/components/SkeletonGradient';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoadingWrapper = styled.div.withConfig({
  displayName: "EditorLoadingState__LoadingWrapper",
  componentId: "sc-16vkufo-0"
})(["", " flex-grow:1;"], flexColumnStyles);
const EditorLoadingState = /*#__PURE__*/memo(({
  minHeight
}) => {
  return /*#__PURE__*/_jsxs(LoadingWrapper, {
    children: [/*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: minHeight ? `${minHeight}px` : 'auto',
      flexGrow: 1,
      padding: "500",
      alignItems: "stretch",
      children: /*#__PURE__*/_jsx(SkeletonView, {
        inlineSize: "100%",
        blockSize: "auto",
        minBlockSize: "15px"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      inlineSize: "100%",
      blockSize: "50px",
      justifyContent: "end",
      alignItems: "center",
      overflow: "hidden",
      "data-loading": "true",
      children: /*#__PURE__*/_jsx(SkeletonGradient, {})
    })]
  });
});
EditorLoadingState.displayName = 'EditorLoadingState';
export default EditorLoadingState;